// extracted by mini-css-extract-plugin
export default {"Box":"archive-header-wrapper-module__Box--o6FiG","Box_1":"archive-header-wrapper-module__Box_1--nVdvN"};